import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ContactUs = () => {
  return (
    <div className="overflow-x-hidden bg-gray-50">
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <section className="relative py-12 sm:py-16 lg:pt-20 xl:pb-0">
        <div className="px-4 mx-auto text-center max-w-7xl sm:px-6 lg:px-8">
          <p className="inline-flex px-4 py-2 text-base text-gray-900 border border-gray-200 rounded-full">Reach Out To Us Anytime</p>
          <h1 className="mt-5 text-4xl font-bold text-gray-900 sm:text-5xl lg:text-6xl">We’re Here to Help</h1>
          <p className="max-w-md mx-auto mt-6 text-base text-gray-600">Ask us questions, tell us your needs, or just say hello!</p>
          <div className="relative inline-flex mt-10 group">
            <div className="absolute opacity-70 -inset-px bg-gradient-to-r from-[#44BCFF] via-[#FF44EC] to-[#FF675E] rounded-xl blur-lg group-hover:opacity-100 animate-tilt" />
            <a href="#contact" className="relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-gray-900 rounded-xl hover:bg-gray-700">Send Us a Message</a>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="px-4 py-16 bg-gray-100 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 mx-auto max-w-7xl lg:grid-cols-2">
          {/* Contact Form */}
          <div className="p-8 bg-white rounded-lg shadow-lg">
            <h2 className="mb-4 text-3xl font-bold text-gray-900">Send Us a Message</h2>
            <p className="mb-6 text-gray-600">Fill out the form below and we’ll get back to you shortly.</p>
            <form action="https://fabform.io/f/YOUR_FORM_ID" method="post" className="space-y-6">
              <div>
                <label className="block mb-1 font-semibold text-gray-700">Name</label>
                <input type="text" name="name" required className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-blue-500" placeholder="Your Name" />
              </div>
              <div>
                <label className="block mb-1 font-semibold text-gray-700">Email</label>
                <input type="email" name="email" required className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-blue-500" placeholder="Your Email" />
              </div>
              <div>
                <label className="block mb-1 font-semibold text-gray-700">Message</label>
                <textarea name="message" rows="5" required className="w-full px-4 py-2 border rounded focus:ring-2 focus:ring-blue-500" placeholder="Your Message..."></textarea>
              </div>
              <div className="flex justify-end">
                <button type="submit" className="px-6 py-3 font-bold text-white bg-blue-600 rounded hover:bg-blue-700">Send</button>
              </div>
            </form>
          </div>

          {/* Google Map */}
          <div className="w-full h-[400px] rounded-lg overflow-hidden shadow-lg">
            <iframe
              title="School Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3971.4844559187784!2d6.524379814143532!3d6.453060995316007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1041ae2b5cfbb2b5%3A0x72fa1095be6fc7e!2sLagos%20Island!5e0!3m2!1sen!2sng!4v1620471719640!5m2!1sen!2sng"
              width="100%"
              height="100%"
              loading="lazy"
              className="w-full h-full border-0"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ContactUs;
